
import {computed, defineComponent, ref} from "vue";
import {useRoute} from "vue-router";
import {decomposeLocale, LANGS_FOR_COUNTRY_TEST, loadLocaleMessages, setI18nLanguage} from "@/i18n";
import {useI18n} from "vue-i18n";
import {i18n} from "@/main";
import useModal from "@/hooks/Modal";
import InlineSVG from "@/components/InlineSVG.vue";
import Modal from "@/components/Modal.vue";
import CustomButton from "@/components/CustomButton.vue";
import CustomSelect, {CustomSelectItem} from "@/components/CustomSelect.vue";
import {itExist} from "@/utils/general-utils";

export default defineComponent({
  name: 'ProductPageConfig',
  components: {
    CustomSelect,
    Modal,
    InlineSVG,
    CustomButton,
  },

  setup() {
    const {locale: defaultLocale} = useI18n({useScope: 'global'});
    const {closeModal, openModal, currentModal} = useModal();
    const route = useRoute();
    const modalName = "settings";
    const {lang: defaultLang, countryCode: defaultCountryCode} = decomposeLocale(defaultLocale.value);

    const {lang: paramLang, countryCode: paramCountryCode} = decomposeLocale(route.query.locale as string);
    let initialLang = itExist(paramLang) ? paramLang : defaultLang;
    let initialCoutryCode = itExist(paramCountryCode) ? paramCountryCode : defaultCountryCode;
    const langRef = ref(initialLang);
    const countryCodeRef = ref(initialCoutryCode);

    // Change translations if default configuration is not suitable
    if (initialLang !== defaultLang || initialCoutryCode !== defaultCountryCode) {
      changeLocale();
    }

    const countryCodeList: CustomSelectItem[] = Object.keys(LANGS_FOR_COUNTRY_TEST).map((countryCode) => {
      return {
        value: countryCode,
        label: countryCode,
      };
    });
    const langList = computed<CustomSelectItem[]>(() => {
      const arr: string[] = LANGS_FOR_COUNTRY_TEST[countryCodeRef.value] ?? [];
      return arr.map((lang) => {
        return {
          value: lang,
          label: lang,
        };
      })
    });

    async function changeLocale() {
      const newLocale = `${langRef.value}_${countryCodeRef.value}`;
      await loadLocaleMessages(i18n, newLocale);
      setI18nLanguage(i18n, newLocale);
    }

    function validateModal() {
      changeLocale();
      initialLang = langRef.value;
      initialCoutryCode = countryCodeRef.value;
      closeModal();
    }

    function cancelModal() {
      if (langRef.value !== initialLang || countryCodeRef.value !== initialCoutryCode) {
        langRef.value = initialLang;
        countryCodeRef.value = initialCoutryCode;
      }
      closeModal();
    }

    return {
      openModal,
      cancelModal,
      validateModal,
      currentModal,
      modalName,
      countryCodeList,
      langList,
      langRef,
      countryCodeRef,
    };
  },
});
